import { Component, Input } from '@angular/core';

import { IIdentity, CellComponent, CellContext } from '../../models';

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
})
export class DeleteButtonComponent<T extends IIdentity>
  implements CellComponent<T>
{
  @Input({ required: true }) context!: CellContext<T>;
}
